import { useMemo } from 'react';

/**
 * Memoizes a grid-config factory call so the resulting config has stable
 * identity for the lifetime of the page. Use in place of bare
 * `useMemo(() => makeFooGridConfig({...}), [])` whenever the factory captures
 * row-action handlers (open dialog, dispatch async action, etc.).
 *
 * **Caller contract:** every callback in `args` must have stable identity
 * across renders (e.g. React `useState` setters, actions returned by
 * `useDispatchActions`). Freshly-created arrows do not qualify.
 */
export function useGridConfig<TArgs, TConfig>(
  factory: (args: TArgs) => TConfig,
  args: TArgs,
): TConfig {
  return useMemo(() => factory(args), []);
}
